import { Autocomplete, Divider, Grid, IconButton, TextField, Typography, useMediaQuery } from '@mui/material'
import React, { useContext, useState } from 'react';
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import styles from "../../../assets/styles/componentStyles/dataconnector.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import Required from '../../utility/required';
import GlobalButton from '../../utility/globalButton/button';
import { createDataConnectorAssignementPayload, DataConnectorAssignment, dataConnectorAssignmentType, dataConnectorList } from '../../../models/axiosModel';
import { useSearchParams } from 'react-router-dom';
import { ChatbotContext, ChatbotContextPayload } from '../../../context/chatbotContext';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { DataConnectorContext, DataConnectorContextpayload } from '../../../context/dataConnectorContext';
import RefreshIcon from '@mui/icons-material/Refresh';
import { filterAutocompleteOptionsWithException, isSystemApi } from '../../../utils/constants';
import { createNewCustomAPIObj, renderCustomAPIOptions } from '../flowBuilder/flowBuilderConstants';
import { useGenericStore } from '../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface AssignDataConnectorPopupProps {
    getChatbotDataConnectorListApiCall: () => void,
    setFlagAssignDataConnectorPopup: React.Dispatch<React.SetStateAction<boolean>>,
}

const AssignDataConnectorPopup: React.FC<AssignDataConnectorPopupProps> = (props) => {

    const { getChatbotDataConnectorListApiCall, setFlagAssignDataConnectorPopup } = props;

    const { chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload;
    const { dataConnectorList, dataConnectorAssignmentType, assignDataConnectorAssignment } = useContext(DataConnectorContext) as DataConnectorContextpayload;
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [searchParams] = useSearchParams();
    const chatbotId = searchParams.get("chatbot_id") ?? (chatBotDetails ? chatBotDetails.chatbot_id : "");

    const flagMobileScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 600px)');
    

    const [payload, setPayload] = useState<createDataConnectorAssignementPayload>({
        chatbot_data_connector_id: -1,
        data_connector_assignment_type_id: dataConnectorAssignmentType.find((assignment: dataConnectorAssignmentType) => assignment.data_connector_assignment_type_name.toLowerCase() == "chatbot")?.data_connector_assignment_type_id || 1,
        data_connector_assignment_unique_id: Number(chatbotId),
    });

    const onChangeOfDataConnector = (value: dataConnectorList | null) => {
        if (value && value?.chatbot_data_connector_id == -1 && value?.data_connector_functions?.data_connector_function_name == "Create New Custom API") {
            window.open('/customAPI/createCustomAPI', '_blank')
        } else {
            setPayload((prevState) => ({
                ...prevState,
                chatbot_data_connector_id: value ? value.chatbot_data_connector_id : -1,
            }));
        }
    }

    const getDataConnectorOptionsForAutoComplete = (): dataConnectorList[] => {
        let arr: dataConnectorList[] = [];
        if (dataConnectorList) {
            arr = dataConnectorList?.filter((list: dataConnectorList) =>
                !(list.data_connector_assignment.some((assignment: DataConnectorAssignment) => assignment.data_connector_assignment_unique_id == Number(chatbotId)))
                && !(isSystemApi(list?.chatbot_data_connector_function_path) && list?.flag_allow_voice_agent_assignment)
            ) || [];
        }
        return [...arr, createNewCustomAPIObj]
    }

    const disabledAssignBtn = () => {
        if (payload.chatbot_data_connector_id == -1) {
            return true;
        }
        return false;
    }

    const handleAssignBtnClick = async () => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const res = await assignDataConnectorAssignment(payload);
        // ApiCall();
        if (res.status) {
            showSuccess("Custom API Assigned Successfully")
            getChatbotDataConnectorListApiCall();
        } else {
            handleError(res);
        }
        setFlagAssignDataConnectorPopup(false);
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }

    const handleCancelBtnClick = () => {
        setPayload({
            chatbot_data_connector_id: -1,
            data_connector_assignment_type_id: dataConnectorAssignmentType.find((assignment: dataConnectorAssignmentType) => assignment.data_connector_assignment_type_name.toLowerCase() == "chatbot")?.data_connector_assignment_type_id || 1,
            data_connector_assignment_unique_id: Number(chatbotId),
        });
        setFlagAssignDataConnectorPopup(false);
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container direction={"column"} justifyContent={"center"}>
                        <Grid item textAlign={"center"}>
                            <Typography className={contactStyles.popupTitleTypography}>Assign Custom API</Typography>
                        </Grid>

                        <Divider className={contactStyles.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={contactStyles.popupBodyGridContainer} gap={1}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"} className={globalStyles.relativePosition}>
                                        <Grid item xs={12}>
                                            <Typography className={contactStyles.popupFieldTypography}>Custom API<Required /></Typography>
                                        </Grid>
                                        <Grid item xs={flagMobileScreen ? 10 : 11}>
                                            <Autocomplete
                                                className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                options={getDataConnectorOptionsForAutoComplete()}
                                                getOptionLabel={(option: dataConnectorList) =>
                                                    `${option?.function_method_name || "System API"} - ${option?.data_connector_functions?.data_connector_function_name || ""}`
                                                }
                                                value={dataConnectorList?.find((list: dataConnectorList) => list.chatbot_data_connector_id == payload.chatbot_data_connector_id) || null}
                                                onChange={(_, value: dataConnectorList | null) => onChangeOfDataConnector(value)}
                                                ListboxProps={{ className: contactStyles.singleContactListbox }}
                                                filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "data_connector_functions?.data_connector_function_name", "chatbot_data_connector_id")}
                                                renderOption={(props, option) => renderCustomAPIOptions(props, option)}
                                                renderInput={(params) => <TextField {...params} placeholder="Select Custom API" />}
                                            />
                                        </Grid> 
                                        <Grid item xs={flagMobileScreen ? 1 : 0.5} className={globalStyles.absolutePosition} right={"10px"} bottom={"1px"}>
                                            <IconButton
                                                className={contactStyles.headerButtonStyle}
                                                onClick={() => getChatbotDataConnectorListApiCall()}
                                            >
                                                <RefreshIcon className={`${styles.primaryColor}`} />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item>
                            <Grid container justifyContent={"center"} alignItems={"center"} gap={"12px"} padding={"20px 0"}>
                                <Grid item>
                                    <GlobalButton
                                        buttonText="Cancel"
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='borderedButtonStyle'
                                        onClick={() => handleCancelBtnClick()}
                                    >
                                    </GlobalButton>
                                </Grid>
                                <Grid item>
                                    <GlobalButton
                                        buttonText={"Assign"}
                                        sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                        className='primaryButtonStyle'
                                        disabled={disabledAssignBtn()}
                                        onClick={() => handleAssignBtnClick()}
                                    >
                                    </GlobalButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AssignDataConnectorPopup
